/* eslint-disable max-params */
/* eslint-disable no-unused-vars */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import { NUMBER } from "../../../constants/app-constants";
import { Heading } from "@cars24/turbo-web/lib/heading";
import { AccordionList } from "@cars24/turbo-web/lib/accordion-list";
import { Accordion } from "@cars24/turbo-web/lib/accordion";
import SchemaValuationFaq from "../../shared/schema-valuation-faq";

const initialOpenIndexes = [NUMBER.ZERO];

const Faq = ({ faqList = [] }) => {
    const { tokens } = useTokens();
    const { spacing_16: spacing } = tokens || {};

    return (
        <div styleName={"styles.faqContainer"}>
            <div styleName={"styles.container"}>
                <div styleName={"styles.mainContainer"}>
                    <Heading level={NUMBER.TWO} isBold>
            Frequently asked questions
                    </Heading>
                    <AccordionList
                        initialOpenIndexes={initialOpenIndexes}
                        items={faqList}
                        gap={spacing}
                    >
                        {(item, index, isOpen, onAccordionClick) => (
                            <Accordion
                                key={item.id}
                                title={item.question}
                                isOpen={isOpen}
                                onChange={() => onAccordionClick({ index })}
                                size="regular"
                                variant="secondary"
                            >
                                <div
                                    styleName={"styles.content"}
                                    dangerouslySetInnerHTML={{
                                        __html: item.answer
                                    }}
                                />
                            </Accordion>
                        )}
                    </AccordionList>
                </div>
            </div>
            <SchemaValuationFaq faqs={faqList} />
        </div>
    );
};

Faq.propTypes = {
    faqList: PropTypes.array
};

export default Faq;
